export default __webpack_public_path__ + "static/media/dreamstime_s_37965548.6290859c.jpg";